import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TrainingPlanning } from './training-planning.model';

@Injectable()
export class TrainingPlanningService {
    constructor(private http: HttpClient) {}

    remove(trainingId: any, id: any, callback: any): Observable<any> {
        return this.http
            .delete<any>(
                '/api/trainings/' + trainingId + '/planned-sessions/' + id
            )
            .pipe(map(() => callback()));
    }

    findAllByTrainingId(trainingId: number): Observable<TrainingPlanning[]> {
        return this.http.get<TrainingPlanning[]>(
            '/api/trainings/' + trainingId + '/planned-sessions'
        );
    }

    findById(trainingId: any, id: any): Observable<TrainingPlanning> {
        return this.http.get<TrainingPlanning>(
            '/api/trainings/' + trainingId + '/planned-sessions/' + id
        );
    }

    update(trainingPlanning: TrainingPlanning) {
        return this.http.put(
            '/api/trainings/' +
                trainingPlanning.trainingId +
                '/planned-sessions/' +
                trainingPlanning.id,
            trainingPlanning
        );
    }

    create(trainingPlanning: TrainingPlanning) {
        return this.http.post(
            '/api/trainings/' +
                trainingPlanning.trainingId +
                '/planned-sessions',
            trainingPlanning
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/training/planning/training-planning.service.ts